jQuery(document).ready(function ($) {
    var $contactPopup = $('#contact-popup');
    if ($contactPopup.length) {
        $('a[href*="#contact"]').on('click', function (e) {
            e.preventDefault();
            $contactPopup.addClass('show');

            var current = $(window).scrollTop();
            $(window).scroll(function () {
                $(window).scrollTop(current);
            });
        });

        // If an event gets to the body
        $(".popup").click(function () {
            $(".popup").removeClass('show');
            $(window).off('scroll');
        });

        // Prevent events from getting pass .popup
        $(".popup__window").on('click', function (e) {
            e.stopPropagation();
        });

        $('.close').on('click', function () {
            $(window).off('scroll');
            $('.popup').removeClass('show');
        });
    }
});
